angular.module('account.roles.index', [
    'security.authorization',
    'services.utility',
    'resources.Role',
    'services.adminResource',
    'services.search',
    'filters.timeAgo'
  ])
  
  .config(["$stateProvider", function($stateProvider) {
    $stateProvider
      .state('account.roles', {
        url: '/roles?limit&oficial&skip&name',
        title: 'Manage Roles',
        views: {
          'main@': {
            template: require('./roles.tpl.html'),
            controller: 'RolesIndexCtrl'
          }
        },
        resolve: {
          user: ["User", "$state", "$location", function(User, $state, $location) {
            return User.current(function (user) {
              if (user && user.is_active && user.permissions.is_admin) {
                return user;
              }
              return $state.go('unauthorized');
            }).$promise;
          }],
          initSearch: ["searchService", "Role", "$state", function (searchService, Role, $state) {
            searchService.setSearchFn(Role.search);
            searchService.setRedirectBase('/account/roles/edit');
          }]
        }
      });
  }])
  
  .controller('RolesIndexCtrl',
    ["$scope", "$route", "$location", "$log", "utility", "adminResource", "searchService", "$stateParams", "user", function($scope, $route, $location, $log, utility, adminResource, searchService, $stateParams, user) {
      $scope.isAdmin = user.permissions.is_admin;
      $scope.search = searchService.search;

      // // typeahead-on-select="getRole($item)"
      // $scope.getRole = function ($item) {
      //     $scope.role = $item.name + ' performance';
      //     $scope.query.name = $scope.query.role.name;
      // };

      // local var
      var deserializeData = function(data){
        $scope.page = data.meta.page;
        $scope.roles = data.data;
      };
  
  
      var fetchData = function () {
        //console.log("$scope.query------->>>>>>>>"+JSON.stringify($scope.query));
        adminResource.searchRoles($scope.query).then(function(data) {
          // console.log("data------->>>>>>>>"+JSON.stringify(data));
            deserializeData(data);
          //update url in browser addr bar
          // $location.search($scope.query);
        }, function(e) {
          $log.error(e);
        });
      };
  
      $scope.$watchCollection('query', _.debounce(function (newState, oldState) {
        if ( angular.equals(newState, oldState) ) {
          return;
        }
        fetchData();
      }, 700));
  
      $scope.limits = [
        {label: "10 Materiałów", value: 10},
        {label: "20 Materiałów", value: 20},
        {label: "50 Materiałów", value: 50},
        {label: "100 Materiałów", value: 100}
      ];
  
      $scope.query = $location.search();
      $scope.query.limit = $scope.query.limit || $scope.limits[0].value;
      $scope.query.name = $scope.query.name || '';
      fetchData();


      $scope.openTabByType = function(type) {
        $scope.roles = [];
        $scope.query.type = type;
      }
    }]);
  


// WEBPACK FOOTER //
// ./client/src/app/account/roles/roles.js